import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isNaN, cloneDeep } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { Box, Button, Typography } from '@mui/material';
import turf from '@turf/turf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';
import * as videoCalculate from '../../../api/Videos/videos-calculations';
import Videos from '../../../api/Videos/Videos';
import Annotations from '../../../api/Annotations/Annotations';
import {
  ELEMENT_TYPES,
  LIBRARY_ICON_TYPES
} from '../../../api/AnnotationTemplates/AnnotationTemplates';
import Loading from '../Loading';

const LocationSimpleComponent = props => {
  const {
    annotationList,
    isPublicMap,
    loading,
    locationSettings,
    MapProps,
    userProps,
    videoToSave
  } = props;

  const {
    buttonCurrentLocation,
    intervalTime,
    userNameTitle,
    savingSystem,
    showAddress,
    showTitle,
    templateConfiguration,
    title
  } = locationSettings;
  const [loadingComponent, setLoadingComponent] = React.useState(true);
  const [createdAnnotationState, setCreatedAnnotationState] = React.useState(false);
  const [templateSelected, setTemplateSelected] = React.useState(true);

  const addDependDataType = (element, value) => {
    if (element.dataType && value) {
      if (element.dataType === 'text' && typeof value !== 'string') {
        return value.toString();
      }
      if (element.dataType === 'number' && typeof value !== 'number') {
        return parseInt(value, 10);
      }
    } else {
      return value;
    }
    return value;
  };

  const fechaAGpsEnMicrosegundos = () => {
    const fechaConHora = new Date();
    const fechaReferenciaGps = new Date('1980-01-06T00:00:00Z');
    const diferencia = fechaConHora.getTime() - fechaReferenciaGps.getTime();
    const diferenciaEnMicroSegundos = diferencia * 1000;
    return diferenciaEnMicroSegundos;
  };

  const templateConfigurationFunction = (template, addressProp, coordsProp) => {
    const config = templateConfiguration.templates.find(index => index.templateId === template._id);
    if (config) {
      config.elements.forEach(configItem => {
        const matchingElement = template.elements.find(
          element => element.order === configItem.order
        );
        if (matchingElement && configItem.nameTable) {
          if (configItem.nameTable === 'latitud') {
            matchingElement.value = addDependDataType(matchingElement, coordsProp[0]);
          } else if (configItem.nameTable === 'longitud') {
            matchingElement.value = addDependDataType(matchingElement, coordsProp[1]);
          } else if (configItem.nameTable === 'address') {
            matchingElement.value = addDependDataType(matchingElement, addressProp.address);
          } else if (configItem.nameTable === 'country') {
            matchingElement.value = addDependDataType(matchingElement, addressProp.country);
          } else if (configItem.nameTable === 'road') {
            matchingElement.value = addDependDataType(matchingElement, addressProp.road);
          } else if (configItem.nameTable === 'postcode') {
            matchingElement.value = addDependDataType(matchingElement, addressProp.postcode);
          } else if (configItem.nameTable === 'city') {
            matchingElement.value = addDependDataType(matchingElement, addressProp.city);
          } else if (configItem.nameTable === 'userId') {
            const newUser = isEmpty(userProps.userId) ? MapProps.map.publicId : userProps.userId;
            matchingElement.value = addDependDataType(matchingElement, newUser);
          } else if (configItem.nameTable === 'userLocalId') {
            matchingElement.value = addDependDataType(matchingElement, userProps.userLocalId.id);
          } else if (configItem.nameTable === 'userLocalName') {
            matchingElement.value = addDependDataType(matchingElement, userProps.userLocalId.name);
          } else if (configItem.nameTable === 'mapId') {
            matchingElement.value = addDependDataType(matchingElement, MapProps.map._id);
          } else if (configItem.nameTable === 'fecha') {
            matchingElement.value = addDependDataType(
              matchingElement,
              new Date().toLocaleDateString()
            );
          } else if (configItem.nameTable === 'hora') {
            matchingElement.value = addDependDataType(
              matchingElement,
              new Date().toLocaleTimeString()
            );
          } else if (configItem.nameTable === 'tiempoGPS') {
            matchingElement.value = addDependDataType(matchingElement, fechaAGpsEnMicrosegundos());
          }
        }
      });
    }
    return template;
  };

  const renderButtons = buttonConfig => {
    if (!isEmpty(buttonConfig.libraryIcon)) {
      if (buttonConfig.libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME) {
        return <FontAwesomeIcon icon={buttonConfig.iconFontawesome} size="lg" />;
      }
      if (buttonConfig.libraryIcon === LIBRARY_ICON_TYPES.SVG) {
        return (
          <img
            src={buttonConfig.iconSvg}
            alt={buttonConfig.iconFontawesome}
            style={{ marginRight: '5px', width: '20px', height: '20px' }}
          />
        );
      }
    }

    return '';
  };

  const videoTimeFunction = (currentTimeGPS, coordinates) => {
    let time = 0;
    if (savingSystem === 'incremental') {
      const numerosVideotime = !isEmpty(annotationList)
        ? annotationList.map(objeto => objeto.geoJSON.properties.videoTime)
        : [0];
      time = Math.max(...numerosVideotime) + parseInt(intervalTime, 10) * 1000000;
    } else if (savingSystem === 'location') {
      const coordenadas = [coordinates.lng, coordinates.lat];
      const newPointTurf = turf.point(coordenadas);
      if (videoToSave.coordinatesDataType === 'point') {
        const numerosVideotime = !isEmpty(annotationList)
          ? annotationList.map(objeto => objeto.geoJSON.properties.videoTime)
          : [0];
        time = Math.max(...numerosVideotime) + 1 * 1000000;
      } else {
        const newPointVideo = turf.nearestPointOnLine(videoToSave.track, newPointTurf);
        time = videoCalculate.calculateTimeVideoLine(videoToSave, newPointVideo, annotationList);
      }
    } else if (savingSystem === 'gpsTime') {
      const numerosTimeGPS = !isEmpty(annotationList)
        ? annotationList.map(objeto => objeto.timeGPS)
        : [0];
      const initialTimeGPS = Math.min(...numerosTimeGPS);
      time =
        initialTimeGPS !== 0 && !isNaN(initialTimeGPS)
          ? currentTimeGPS - initialTimeGPS
          : currentTimeGPS;
    } else {
      time += 5 * 1000000;
    }
    return time;
  };

  const vaciarTemplate = () => {
    const annotationTemplateDefault =
      videoToSave &&
      videoToSave.annotationTemplates.find(index => index._id === locationSettings.defaultTemplate);
    annotationTemplateDefault.elements.forEach(item => {
      if (
        item.elementType === ELEMENT_TYPES.MULTIPLEIFRAME ||
        item.elementType === ELEMENT_TYPES.MULTIPLEVIDEOS ||
        item.elementType === ELEMENT_TYPES.MULTIPLEPICTURES
      ) {
        // eslint-disable-next-line no-param-reassign
        item.multiValues = [];
      } else if (item.elementType === ELEMENT_TYPES.MULTIPLEIMAPS) {
        // eslint-disable-next-line no-param-reassign
        item.multipleMaps = [];
      } else if (item.elementType === ELEMENT_TYPES.MULTIPLEPOINTCLOUD) {
        // eslint-disable-next-line no-param-reassign
        item.multiplePointCloud = [];
      } else {
        // eslint-disable-next-line no-param-reassign
        item.value = '';
      }
    });
    return annotationTemplateDefault;
  };

  const createAnnotation = async (item, coordinates) => {
    const annotationState = !!MapProps.match.params.annotation_id;
    const userId = isEmpty(userProps.userId) ? userProps.userLocalId.id : userProps.userId;
    try {
      if (isEmpty(item)) throw new Error('No annotation template selected.');
      const templateAnnotation = cloneDeep(item);
      if (userNameTitle && userNameTitle === true) {
        templateAnnotation.name = !isEmpty(userProps.name) ? userProps.name : item.name;
      }
      const currentTimeGPS = fechaAGpsEnMicrosegundos();
      const videoTimeValue = videoTimeFunction(currentTimeGPS, coordinates);
      const videoPosition = { x: 370.75, y: 137, width: 549, height: 309 };
      const annotationToSave = {
        geoJSON: {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [coordinates[1], coordinates[0]]
          },
          properties: {
            template: templateAnnotation,
            video: videoToSave._id,
            videoTime: parseInt(videoTimeValue, 10),
            videoPosition,
            isProyected: true,
            alias: !isEmpty(userProps.name) ? userProps.name : '',
            mapID: MapProps.map._id
          }
        },
        origin: 'manual',
        isTracking: false
      };
      if (annotationState === true) {
        await methodPromise(
          'annotations.update',
          { ...annotationToSave, _id: MapProps.match.params.annotation_id },
          true,
          userId
        );
        Bert.alert('Annotation updated', 'success');
      } else {
        await methodPromise(
          'annotations.insert',
          { ...annotationToSave, owner: userId },
          isPublicMap,
          userId
        );
        Bert.alert('Annotation created', 'success');
      }
      setCreatedAnnotationState(true);
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const obtenerUbicacion = async () => {
    if ('geolocation' in navigator) {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          position => {
            const latitud = position.coords.latitude;
            const longitud = position.coords.longitude;
            const coordenadas = [latitud, longitud];
            resolve(coordenadas);
          },
          error => {
            switch (error.code) {
              case error.PERMISSION_DENIED:
                Bert.alert('El usuario denegó la solicitud de geolocalización.', 'warning');
                break;
              case error.POSITION_UNAVAILABLE:
                reject(new Error('La información de la ubicación no está disponible.'));
                break;
              case error.TIMEOUT:
                reject(new Error('Se ha agotado el tiempo de espera para obtener la ubicación.'));
                break;
              case error.UNKNOWN_ERROR:
                reject(new Error('Se produjo un error desconocido al obtener la ubicación.'));
                break;
              default:
                reject(new Error('Se produjo un error desconocido al obtener la ubicación.'));
                break;
            }
          }
        );
      });
    }
    return Promise.reject(new Error('La geolocalización no está soportada por este navegador.'));
  };

  const coordinatesAddress = async coordinates => {
    if (!isEmpty(coordinates)) {
      try {
        const response = await fetch(
          'https://sd1.ipsgeoprocesing.ipsilum.com/MG/geolocation/exec_geocodificacion',
          {
            method: 'POST',
            body: JSON.stringify({
              point: coordinates
            }),
            headers: { 'Content-Type': 'application/json' },
            mode: 'cors',
            credentials: 'omit',
            referrerPolicy: 'no-referrer'
          }
        );
        const respuesta = await response.json();
        if (respuesta) {
          return respuesta;
        }
        Bert.alert('No se encontró la dirección', 'info');
        return '';
      } catch (error) {
        console.error('Error al obtener la dirección:', error);
        Bert.alert('Error al obtener la dirección', 'error');
        return '';
      }
    }
    return '';
  };

  React.useEffect(() => {
    const handleCoordinatesAndTemplate = async () => {
      try {
        const coordinates = await obtenerUbicacion();
        const annotationTemplateDefault = vaciarTemplate();

        if (!coordinates || isEmpty(coordinates)) {
          setTemplateSelected(cloneDeep(annotationTemplateDefault));
          createAnnotation(annotationTemplateDefault, null);
          setLoadingComponent(false);
          return;
        }

        let newAddress = {};
        if (showAddress) {
          try {
            newAddress = await coordinatesAddress(coordinates);
          } catch (error) {
            console.error('No se encuentra la dirección seleccionada.', error);
          }
        }

        const updatedTemplate = templateConfiguration.configuration
          ? templateConfigurationFunction(annotationTemplateDefault, newAddress, coordinates)
          : annotationTemplateDefault;

        setTemplateSelected(updatedTemplate);
        createAnnotation(updatedTemplate, coordinates);
      } catch (error) {
        console.error('Error al obtener la ubicación:', error);
      } finally {
        setLoadingComponent(false);
      }
    };

    if (!loading) {
      handleCoordinatesAndTemplate();
    }
  }, [loading, showAddress, templateConfiguration]);

  return (
    <>
      {loadingComponent === true ? (
        <Loading />
      ) : (
        <Box display="flex" flexDirection="column" gap={2} overflowY="hidden" width="90%">
          {showTitle && showTitle === true && (
            <Typography align="center" sx={{ color: 'black', fontFamily: 'Arial' }} variant="h3">
              {title}
            </Typography>
          )}
          {createdAnnotationState === true ? (
            <Typography align="center" sx={{ color: 'black', fontFamily: 'Arial' }} variant="h5">
              Su ubicación se ha enviado correctamente.
            </Typography>
          ) : (
            <>
              <Typography align="center" sx={{ color: 'black', fontFamily: 'Arial' }} variant="h5">
                No se ha podido enviar su ubicación selecciona el siguiente botón para volverla a
                enviar.
              </Typography>
              <Button
                onClick={async () => {
                  const coordinates = await obtenerUbicacion();
                  if (showAddress && showAddress === true) {
                    const newAddress = await coordinatesAddress(coordinates);
                    const updatedTemplateSelected = templateConfigurationFunction(
                      templateSelected,
                      newAddress,
                      coordinates
                    );
                    createAnnotation(updatedTemplateSelected, coordinates);
                  } else {
                    createAnnotation(templateSelected, coordinates);
                  }
                }}
                sx={{
                  color: '#2A3F90',
                  backgroundColor: 'white',
                  borderColor: '#2A3F90'
                }}
              >
                {buttonCurrentLocation.icon
                  ? buttonCurrentLocation.icon
                  : renderButtons(buttonCurrentLocation)}{' '}
                {!isEmpty(buttonCurrentLocation.name) && buttonCurrentLocation.name}
              </Button>
            </>
          )}
        </Box>
      )}
    </>
  );
};

export default withTracker(({ locationSettings }) => {
  const videosSub = Meteor.isClient && Meteor.subscribe('videos.view', locationSettings.videoId);
  const videoToSave = Videos.findOne({ _id: locationSettings.videoId, deleted: { $eq: 'no' } });
  const annotationSub = Meteor.subscribe('annotations', locationSettings.videoId);
  const annotationList = Annotations.find({}, { sort: { videoTime: 1 } }).fetch();
  const loading = !videosSub.ready() && !annotationSub.ready();

  return {
    annotationList,
    loading,
    videoToSave
  };
})(LocationSimpleComponent);

LocationSimpleComponent.defaultProps = {
  annotationList: [],
  isPublicMap: false,
  loading: false,
  MapProps: {},
  userProps: {},
  videoToSave: {}
};
LocationSimpleComponent.propTypes = {
  annotationList: PropTypes.array,
  isPublicMap: PropTypes.bool,
  loading: PropTypes.bool,
  locationSettings: PropTypes.object.isRequired,
  MapProps: PropTypes.object,
  userProps: PropTypes.object,
  videoToSave: PropTypes.object
};
